import { BASE_URL } from 'constants/api';

const SPREADSHEETS_URL = `https://docs.google.com/spreadsheets/d/`;

export const INSTRUCTIONS_FOR_EXISTING_PLANS = `${SPREADSHEETS_URL}1pWPniZaJ1bQovh4lGi_bq9cK9tyC4UrzirfkCBRxKQM/edit?usp=sharing`;
export const INSTRUCTIONS_FOR_CREATING_PLANS = `${SPREADSHEETS_URL}1sbXSwnA4NbgbJcRKyqNOOffjdMf4KFVkU--Wy7zWfZw/edit?usp=sharing`;
export const CSV_LINK_FOR_EXISTING_PLANS = `${SPREADSHEETS_URL}1opT7dsIWcm_ZruPHkDxhwnXlf4z9YU_v1oi5alFdJiA/edit?usp=sharing`;
export const CSV_LINK_FOR_CREATE_PLANS = `${SPREADSHEETS_URL}1V-VzkBBkB1EOLxvfs5O6iDQO0pmLuoJUBE09nB6KEok/edit?usp=sharing`;

export const WEBSITE_PLANS_URL = `${BASE_URL}/pricing/export-plans/`;
export const ONLINE_PLANS_POST_URL = `${BASE_URL}/pricing/generate-plans/`;

export const FORM_DATA = {
  FILE: 'file',
  ACTION: 'action',
  UPDATE: 'update',
  CREATE: 'create',
  MODIFY: 'modify',
  UPLOAD: 'upload',
};

export const ONLINE_PLAN_ACTIONS = {
  UPDATE_EXISTING_PLANS: 'Update Existing Plans',
  CREATE_DEACTIVATE_PLANS: 'Create/Deactivate Plans',
};

export const ERRORS = 'Errors';
export const WEBSITE_PLANS_NAME = 'Website_plans';

export const ALL_TABS = {
  ONLINE_PLANS: 'online-plans',
  PRICING_STRUCTURE: 'pricing-structure',
};

export const TAB_LABELS = {
  'online-plans': 'Online Plans',
  'pricing-structure': 'Pricing Structure',
};

export const UPLOAD_FILE = {
  UPLOAD_UPDATED_PLANS_HERE: 'Upload updated plans here',
  UPLOAD_NEW_FILE_HERE: 'Upload the new file here',
};

export const UPLOADED_FILE_CONTAINS_ERRORS = `No changes were done. The uploaded file contains errors. Please check the downloaded CSV file with 'Errors' column for more details. Please rectify the errors and upload again.`;
export const NOTE_FOR_ERROR_COLUMN = `NOTE: Please delete the errors column before uploading the file. `;
export const SOMETHING_WENT_WRONG = 'Something went wrong';
export const SUCCESSFULLY_SUBMITTED =
  'Successfully submitted. Changes will be reflected in a couple of minutes.';
export const PLEASE_SELECT_FILE = 'Please select file';
export const CSV_CONTENT_TYPE = 'text/csv';
export const CONTENT_TYPE = 'content-type';
export const CONTENT_DISPOSITION = 'content-disposition';
export const POST = 'POST';
export const MULTIPLE_FORM_DATA = 'multipart/form-data';
export const CSV_LINK = 'CSVLink';
